import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.11@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mark",
  "use": "icon-mark-usage",
  "viewBox": "0 0 6 6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 6 6\" id=\"icon-mark\">\r\n<path d=\"M5.404,0H0.596c-0.111,0-0.2,0.089-0.2,0.2c0,0.111,0.089,0.2,0.2,0.2l0,0h0.2V5.77c0,0.179,0.208,0.289,0.371,0.197\r\n\tl1.62-0.913c0.132-0.075,0.294-0.075,0.426,0l1.62,0.913c0.163,0.092,0.37-0.018,0.37-0.197V0.401h0.201\r\n\tc0.109-0.007,0.193-0.103,0.187-0.214C5.584,0.087,5.504,0.007,5.404,0z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol